// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3w_Y4DUYBXxEqbwZ34M9t7{background-color:#fff;color:#25005b;font-size:.71429rem;border:.07143rem solid #25005b;border-radius:.28571rem;font-family:\"Palanquin Dark\",sans-serif;font-weight:700;cursor:pointer;display:inline-flex;text-transform:uppercase}._1GHEJxz-WVwIfDk9eggCMJ{background:linear-gradient(360deg, #772ce8 0%, #25005b 100%);color:#fff}._3w_Y4DUYBXxEqbwZ34M9t7 div{padding:.57143rem 1.78571rem;width:50%;white-space:nowrap}._3w_Y4DUYBXxEqbwZ34M9t7 :first-child{border-right:.07143rem solid #25005b}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"doubleButton": "_3w_Y4DUYBXxEqbwZ34M9t7",
	"doubleButton_selected": "_1GHEJxz-WVwIfDk9eggCMJ"
};
export default ___CSS_LOADER_EXPORT___;
